export default __webpack_public_path__ + "static/media/desk8.fc000cfa.png";